/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserWalletHistoryListRespVo } from './UserWalletHistoryListRespVo';
import {
    UserWalletHistoryListRespVoFromJSON,
    UserWalletHistoryListRespVoFromJSONTyped,
    UserWalletHistoryListRespVoToJSON,
    UserWalletHistoryListRespVoToJSONTyped,
} from './UserWalletHistoryListRespVo';

/**
 * 
 * @export
 * @interface PageDataUserWalletHistoryListRespVo
 */
export interface PageDataUserWalletHistoryListRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataUserWalletHistoryListRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataUserWalletHistoryListRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataUserWalletHistoryListRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<UserWalletHistoryListRespVo>}
     * @memberof PageDataUserWalletHistoryListRespVo
     */
    records?: Array<UserWalletHistoryListRespVo>;
}

/**
 * Check if a given object implements the PageDataUserWalletHistoryListRespVo interface.
 */
export function instanceOfPageDataUserWalletHistoryListRespVo(value: object): value is PageDataUserWalletHistoryListRespVo {
    return true;
}

export function PageDataUserWalletHistoryListRespVoFromJSON(json: any): PageDataUserWalletHistoryListRespVo {
    return PageDataUserWalletHistoryListRespVoFromJSONTyped(json, false);
}

export function PageDataUserWalletHistoryListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataUserWalletHistoryListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(UserWalletHistoryListRespVoFromJSON)),
    };
}

export function PageDataUserWalletHistoryListRespVoToJSON(json: any): PageDataUserWalletHistoryListRespVo {
    return PageDataUserWalletHistoryListRespVoToJSONTyped(json, false);
}

export function PageDataUserWalletHistoryListRespVoToJSONTyped(value?: PageDataUserWalletHistoryListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(UserWalletHistoryListRespVoToJSON)),
    };
}

